var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"column":""}},[_c('h3',{staticClass:"headline grey--text text-xs-center"},[_vm._v(" Dashboard: Technical ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }